import { render, staticRenderFns } from "./layout-box.vue?vue&type=template&id=7aac34c0&scoped=true"
import script from "./layout-box.vue?vue&type=script&lang=js"
export * from "./layout-box.vue?vue&type=script&lang=js"
import style0 from "./layout-box.vue?vue&type=style&index=0&id=7aac34c0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aac34c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aac34c0')) {
      api.createRecord('7aac34c0', component.options)
    } else {
      api.reload('7aac34c0', component.options)
    }
    module.hot.accept("./layout-box.vue?vue&type=template&id=7aac34c0&scoped=true", function () {
      api.rerender('7aac34c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/layout/box/layout-box.vue"
export default component.exports